<template>
    <img v-show="toTopBtn_show" src="../assets/images/home/to_top_btn.png" class="to_top_btn" @click="toTop" alt="">
</template>

<script>
export default {
    name: "to-top-btn",

    components: {

    },
    data: () => ({
        toTopBtn_show: false,
    }),
    created() {

    },
    mounted() {

    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if(val >= 3) {
                this.toTopBtn_show = true;
            } else {
                this.toTopBtn_show = false;
            }
        },
    },
    computed: {
        NAV_ACTIVE_INDEX() {		// 导航栏激活指数
            if(this.$store.state.HOME_FULLPAGE) {       // 异步对象
                return this.$store.state.HOME_FULLPAGE.activeIndex;
            } else {
                return -1;
            }
        },
        HOME_FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        }
    },
    methods: {
        toTop() {
            this.HOME_FULLPAGE.goTo(1)
        }
    },
};
</script>

<style lang="scss" scoped>
.to_top_btn {
    position: fixed;
    bottom: 2%;
    right: 2%;
    cursor: pointer;
    z-index: 999;
}
</style>
